export default __webpack_public_path__ + "static/media/arizona.c9e5f76d.jpg";